import { useConfirmationDialog } from '@factorialco/deprecated-design-system'
import {
  GoalsMetric,
  PerformanceGoalsDeleteMetricDocument,
  PerformanceGoalsEmployeePageDocument,
  PerformanceGoalsEmployeePageMetricGroupsDocument,
  PerformanceGoalsMetricGroupPageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useDeleteMetric = () => {
  const [deleteMetric] = useMutation(PerformanceGoalsDeleteMetricDocument, {
    extractorFn: (deletionData) => deletionData?.goalsMutations?.deleteGoalsMetric,
    refetchQueries: [
      PerformanceGoalsEmployeePageDocument,
      PerformanceGoalsMetricGroupPageDocument,
      PerformanceGoalsEmployeePageMetricGroupsDocument,
    ],
    awaitRefetchQueries: true,
  })

  const { openDialog } = useConfirmationDialog()

  const handleDelete = (metric: Pick<GoalsMetric, '__typename' | 'id' | 'title'>) => {
    openDialog({
      title: i18n.t('performance_goals.delete_key_result_dialog.title', {
        keyResultTitle: metric.title,
      }),
      confirmLabel: i18n.t('performance_goals.delete_key_result_dialog.delete_button'),
      description: i18n.t('performance_goals.delete_key_result_dialog.description'),
      onConfirm: async () => {
        const response = await deleteMetric({
          variables: { id: metric.id },
          update(cache) {
            cache.evict({
              id: cache.identify({ id: metric.id, __typename: metric.__typename }),
            })
          },
        })

        const result = handleResult(response, () => null)
        if (result.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('common.removed_successfully'),
          })
        }
      },
    })
  }

  return {
    handleDelete,
  }
}
